import styled from "styled-components";
import { V3TertiaryCTAColor } from "../Button/V3TertiaryCTA.types";
import { sharedTertiaryCTAMixin } from "../Button/V3TertiaryCTA.styles";

export const V3TertiaryCTALink = styled.a<{ $ctaColor: V3TertiaryCTAColor }>`
    display: inline-block;
    text-decoration: none;
    ${sharedTertiaryCTAMixin};
`;
